import HolifyaLogoComplete from "@/components/HolifyaLogoComplete"
import LoadingSpinner from "@/components/LoadingSpinner"
import { Button } from "@/components/ui/button"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useCheckPurchases } from "../hooks/useCheckPurchases"

const CheckPurchases = () => {

    const navigate = useNavigate()
    const { checkPurchases, isLoading, error } = useCheckPurchases();

    useEffect(() => {
        checkPurchases()
    }, [checkPurchases]);

    // ********************************************************************************
    // TODO [TM]: Dimensioni testi e spazio verticale
    if (isLoading) {
        return (
            <div className="w-full h-screen flex flex-col items-center">
                <div className="w-full h-full flex items-center justify-center">
                    <div className="flex flex-col items-center px-[20px] space-y-[30px]">
                        <HolifyaLogoComplete />
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                ⏳ Attendi...
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Stiamo cercando acquisti associati a questo indirizzo e-mail.
                            </div>
                            <div><LoadingSpinner /></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="w-full h-screen flex flex-col items-center">
                <div className="w-full h-full flex items-center justify-center">
                    <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                        <HolifyaLogoComplete />
                        <div className="font-bold text-[25px] leading-[33px] mb-[20px]">
                            ❌ Errore
                        </div>
                        <div className="font-normal text-[16px] leading-[24px] text-center mb-[30px]">
                            Qualcosa è andato storto, ti chiediamo di riprovare.
                        </div>
                        <Button variant="outline" size="xl" onClick={() => navigate("/")}>
                            Torna alla login page
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return null; // If everything is successful, nothing needs to be rendered (or return fallback UI if desired)
}

export default CheckPurchases
